/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_clear_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Vyprázdnit košík`
};

const da_clear_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Tøm kurv`
};

const de_clear_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Warenkorb leeren`
};

const en_clear_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Clear cart`
};

const es_clear_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Vaciar carrito`
};

const fr_clear_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Vider le panier`
};

const hu_clear_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Kosár ürítése`
};

const it_clear_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Svuota carrello`
};

const nl_clear_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Winkelwagen legen`
};

const pl_clear_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Wyczyść koszyk`
};

const pt_clear_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Esvaziar carrinho`
};

const sv_clear_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Töm kundvagnen`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const clear_cart = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.clear_cart(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("clear_cart", locale)
	if (locale === "cs") return cs_clear_cart(inputs)
	if (locale === "da") return da_clear_cart(inputs)
	if (locale === "de") return de_clear_cart(inputs)
	if (locale === "en") return en_clear_cart(inputs)
	if (locale === "es") return es_clear_cart(inputs)
	if (locale === "fr") return fr_clear_cart(inputs)
	if (locale === "hu") return hu_clear_cart(inputs)
	if (locale === "it") return it_clear_cart(inputs)
	if (locale === "nl") return nl_clear_cart(inputs)
	if (locale === "pl") return pl_clear_cart(inputs)
	if (locale === "pt") return pt_clear_cart(inputs)
	return sv_clear_cart(inputs)
};